import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5485bf4e")

_pushScopeId("data-v-5485bf4e")
const _hoisted_1 = { class: "operates" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  const _component_ElementCreateSelection = _resolveComponent("ElementCreateSelection")
  const _component_AlignmentLine = _resolveComponent("AlignmentLine")
  const _component_MultiSelectOperate = _resolveComponent("MultiSelectOperate")
  const _component_Operate = _resolveComponent("Operate")
  const _component_ViewportBackground = _resolveComponent("ViewportBackground")
  const _component_MouseSelection = _resolveComponent("MouseSelection")
  const _component_EditableElement = _resolveComponent("EditableElement")
  const _directive_contextmenu = _resolveDirective("contextmenu")
  const _directive_click_outside = _resolveDirective("click-outside")

  return _withDirectives((_openBlock(), _createBlock("div", {
    class: "canvas",
    ref: "canvasRef",
    onMousewheel: _cache[2] || (_cache[2] = $event => _ctx.handleMousewheelCanvas($event)),
    onMousedown: _cache[3] || (_cache[3] = $event => _ctx.handleClickBlankArea($event))
  }, [
    (_ctx.creatingElement)
      ? (_openBlock(), _createBlock(_component_ElementCreateSelection, {
          key: 0,
          onCreated: _cache[1] || (_cache[1] = data => _ctx.insertElementFromCreateSelection(data))
        }))
      : _createCommentVNode("", true),
    _createVNode("div", {
      class: "viewport-wrapper",
      style: {
        width: _ctx.viewportStyles.width * _ctx.canvasScale + 'px',
        height: _ctx.viewportStyles.height * _ctx.canvasScale + 'px',
        left: _ctx.viewportStyles.left + 'px',
        top: _ctx.viewportStyles.top + 'px',
      }
    }, [
      _createVNode("div", _hoisted_1, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.alignmentLines, (line, index) => {
          return (_openBlock(), _createBlock(_component_AlignmentLine, {
            key: index,
            type: line.type,
            axis: line.axis,
            length: line.length
          }, null, 8, ["type", "axis", "length"]))
        }), 128)),
        (_ctx.activeElementIdList.length > 1)
          ? (_openBlock(), _createBlock(_component_MultiSelectOperate, {
              key: 0,
              elementList: _ctx.elementList,
              scaleMultiElement: _ctx.scaleMultiElement
            }, null, 8, ["elementList", "scaleMultiElement"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.elementList, (element) => {
          return (_openBlock(), _createBlock(_component_Operate, {
            key: element.id,
            elementInfo: element,
            isSelected: _ctx.activeElementIdList.includes(element.id),
            isActive: _ctx.handleElementId === element.id,
            isActiveGroupElement: _ctx.activeGroupElementId === element.id,
            isMultiSelect: _ctx.activeElementIdList.length > 1,
            rotateElement: _ctx.rotateElement,
            scaleElement: _ctx.scaleElement,
            dragLineElement: _ctx.dragLineElement
          }, null, 8, ["elementInfo", "isSelected", "isActive", "isActiveGroupElement", "isMultiSelect", "rotateElement", "scaleElement", "dragLineElement"]))
        }), 128)),
        _createVNode(_component_ViewportBackground)
      ]),
      _createVNode("div", {
        class: "viewport",
        ref: "viewportRef",
        style: { transform: `scale(${_ctx.canvasScale})` }
      }, [
        (_ctx.mouseSelectionState.isShow)
          ? (_openBlock(), _createBlock(_component_MouseSelection, {
              key: 0,
              top: _ctx.mouseSelectionState.top,
              left: _ctx.mouseSelectionState.left,
              width: _ctx.mouseSelectionState.width,
              height: _ctx.mouseSelectionState.height,
              quadrant: _ctx.mouseSelectionState.quadrant
            }, null, 8, ["top", "left", "width", "height", "quadrant"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.elementList, (element, index) => {
          return (_openBlock(), _createBlock(_component_EditableElement, {
            key: element.id,
            elementInfo: element,
            elementIndex: index + 1,
            isMultiSelect: _ctx.activeElementIdList.length > 1,
            selectElement: _ctx.selectElement
          }, null, 8, ["elementInfo", "elementIndex", "isMultiSelect", "selectElement"]))
        }), 128))
      ], 4)
    ], 4)
  ], 544)), [
    [_directive_contextmenu, _ctx.contextmenus],
    [_directive_click_outside, _ctx.removeEditorAreaFocus]
  ])
})